import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import Menu from '@material-ui/icons/Menu';
import headerStyle from '../../assets/jss/material-kit-react/components/headerStyle';
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.headerColorChange = this.headerColorChange.bind(this);
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    componentDidMount() {
        if (this.props.changeColorOnScroll) {
            window.addEventListener('scroll', this.headerColorChange);
        }
    }
    headerColorChange() {
        const { classes, color, changeColorOnScroll } = this.props;
        const windowsScrollTop = typeof window !== 'undefined' && window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            document.body
                .getElementsByTagName('header')[0]
                .classList.remove(classes[color]);
            document.body
                .getElementsByTagName('header')[0]
                .classList.add(classes[changeColorOnScroll.color]);
        }
        else {
            document.body
                .getElementsByTagName('header')[0]
                .classList.add(classes[color]);
            document.body
                .getElementsByTagName('header')[0]
                .classList.remove(classes[changeColorOnScroll.color]);
        }
    }
    componentWillUnmount() {
        if (this.props.changeColorOnScroll) {
            typeof window !== 'undefined' &&
                window.removeEventListener('scroll', this.headerColorChange);
        }
    }
    render() {
        const { classes, color, rightLinks, leftLinks, brand, fixed, absolute, } = this.props;
        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes[color]]: color,
            [classes.absolute]: absolute,
            [classes.fixed]: fixed,
        });
        const brandComponent = React.createElement(Button, { className: classes.title }, brand);
        return (React.createElement(AppBar, { className: appBarClasses },
            React.createElement(Toolbar, { className: classes.container },
                leftLinks !== undefined ? brandComponent : null,
                React.createElement("div", { className: classes.flex }, leftLinks !== undefined ? (React.createElement(Hidden, { smDown: true, implementation: "css" }, leftLinks)) : (brandComponent)),
                React.createElement(Hidden, { smDown: true, implementation: "css" }, rightLinks),
                React.createElement(Hidden, { mdUp: true },
                    React.createElement(IconButton, { color: "inherit", "aria-label": "open drawer", onClick: this.handleDrawerToggle },
                        React.createElement(Menu, null)))),
            React.createElement(Hidden, { mdUp: true, implementation: "css" },
                React.createElement(Drawer, { variant: "temporary", anchor: 'right', open: this.state.mobileOpen, classes: {
                        paper: classes.drawerPaper,
                    }, onClose: this.handleDrawerToggle },
                    React.createElement("div", { className: classes.appResponsive },
                        leftLinks,
                        rightLinks)))));
    }
}
Header.defaultProp = {
    color: 'white',
};
Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        'primary',
        'info',
        'success',
        'warning',
        'danger',
        'transparent',
        'white',
        'rose',
        'dark',
    ]),
    rightLinks: PropTypes.node,
    leftLinks: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            'primary',
            'info',
            'success',
            'warning',
            'danger',
            'transparent',
            'white',
            'rose',
            'dark',
        ]).isRequired,
    }),
};
export default withStyles(headerStyle)(Header);
//# sourceMappingURL=Header.js.map